export default __webpack_public_path__ + "static/media/a012-2.ba61f2e8.svg";